'use strict'

const phoneNumberconstraint = new RegExp(/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/)
export const phoneNumberErrorMessage = 'Please use a valid phone number in the form of (555) 555 - 5555.'

export function validatePhoneNumber() {
  if (phoneNumberconstraint.test(this.value)) {
    return this.setCustomValidity('')
  }

  return this.setCustomValidity(phoneNumberErrorMessage)
}
